import React from "react"
import classnames from "classnames"
import { InputText, Button, Container, Alert, Section, H3, P } from "AtomicComponents"
import AccordionText from "../AccordionText/AccordionText"
import HeroContent from "../HeroContent/HeroContent"
import RecallDocument from "../RecallDocument/RecallDocument"
import fetchAPI from "AtomicUtils/fetchAPI"
import urlHandler from "AtomicUtils/urlHandler"
import gtmHandler from "AtomicUtils/gtmHandler"
import parseRecallActivities from "AtomicUtils/parseRecallActivities"
import { fromLinkInputs, formLinkSubmit, formSetDefaultValues } from "AtomicUtils/formHandler"
import MESSAGES from "AtomicConstants/MESSAGES"
import styles from "./Recall.less"
import { WINDOW } from "constants/environment"

class Recall extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      form: {
        vinOrRegoInput: {
          validations: {
            required: MESSAGES.REGO_OR_VIN_REQUIRED
          }
        },
        submitButton: { disabled: true }
      },
      recallData: props.recallData
    }
  }

  componentDidMount(){
    const currentURL = new urlHandler(WINDOW.location.href)
    if (currentURL.query.vin || currentURL.query.VIN || this.props.vin){
      const vin = currentURL.query.vin || currentURL.query.VIN || this.props.vin
      formSetDefaultValues(this, { vinOrRegoInput: vin })
      setTimeout(()=>{
        this._handleSubmit()
      }, 100)
    }
  }

  _handleSubmit = async (event) => {
    if (event) event.preventDefault()
    const { loading, form } = this.state
    const currentURL = new urlHandler(WINDOW.location.href)
    if (!loading && !form.submitButton.disabled) {
      await this.setState({
        loading: true
      }, async () => {
        const { endpoint } = this.props
        const { form } = this.state
        await fetchAPI({
          method: "POST",
          url: endpoint,
          body: {
            vin: form.vinOrRegoInput.value
          }
        })
        .then(async (response) => {
          const json = await response.json()
          const { message, recallResponse, statusCode } = json
          if (statusCode !== 200) {
            this.setState({
              errorMessage: message,
              loading: false
            })
          } else {
            currentURL.removeParam("VIN")
            currentURL.setParam("vin", form.vinOrRegoInput.value, true)
            this.setState({
              recallData: recallResponse,
              loading: false
            },() => {
              this._gtmCall(recallResponse)
            })
          }
        })
        .catch(() => {
          this.setState({
            loading: false
          })
        })
      })
    }
  }

  _handleNoRecall = () => {
    const currentURL = new urlHandler(WINDOW.location.href)
    this.setState({
      form: {
        vinOrRegoInput: {
          validations: {
            required: MESSAGES.REGO_OR_VIN_REQUIRED
          }
        },
        submitButton: { disabled: true }
      },
      recallData: null
    }, () => {
      currentURL.removeParam("vin", true)
    })
  }

  _gtmCall = (response) => {
    const { NumberOfAll, Status } = parseRecallActivities(response.recallActivities)

    gtmHandler({
      pageCategory: "Recalls",
      pageAction: `Recalls - Enter VIN - Recall Status "${Status}"`
    })
  }

  render() {
    const {
      heading,
      recallMessageDescription,
      mainHeading,
      mainDescription,
      mainDescriptionWithRecallData,
      recallDocument
    } = this.props
    const { form, loading, errorMessage, recallData } = this.state
    return (
      <div className={classnames({
        [styles.Recall]: true
      })}>
        {!recallData &&
          <Section backgroundColor="#F5F5F5">
            <HeroContent
              heading={mainHeading}
              description={mainDescription}
            />
          </Section>
        }
        <Section backgroundColor="#FFFFFF">
          <Container>
            { !recallData &&
              <div className={classnames({
                [styles.RecallFormSection]: true
              })}>
                <H3 withDetails>
                  {heading}
                </H3>
                <form method="POST" onSubmit={this._handleSubmit}>
                  <div className={classnames({
                    [styles.Form]: true
                  })}>
                    <div className={classnames({
                      [styles.FormInput]: true
                    })}>
                      <InputText
                        name="vinOrRegoInput"
                        label="Enter your VIN here"
                        {...fromLinkInputs(this, "vinOrRegoInput")}
                      />
                    </div>
                    <div className={classnames({
                      [styles.FormInputButton]: true
                    })}>
                      <Button
                        styleName="black"
                        loading={loading}
                        {...formLinkSubmit(this, this._handleSubmit)}
                      >
                        CHECK
                      </Button>
                    </div>
                  </div>
                </form>
                {errorMessage &&
                  <Alert>
                    {errorMessage}
                  </Alert>
                }
                <div>
                  <AccordionText
                    styleName='simple'
                    status={1}
                    title={"Where is my VIN located?"}>
                    <P>
                      {recallMessageDescription}
                    </P>
                  </AccordionText>
                </div>
              </div>
            }
          </Container>
        </Section>
        {recallData &&
          <RecallDocument
            handleNoRecall={this._handleNoRecall}
            {...recallDocument && recallDocument.props}
            {...recallData}
          />
        }
      </div>
    )
  }
}


export default Recall



// WEBPACK FOOTER //
// ./src/AtomicContainers/Recall/Recall.jsx